/**
 * 매장 팩 카테고리 표시명 매핑.
 * store route 전용 util.
 */

const CATEGORY_DISPLAY_MAP: Record<string, string> = {
  베이커리: "빵",
  식사류: "식사",
  샐러드: "샐러드",
  "반찬과 요리": "반찬",
  정육점: "고기",
  기타: "랜덤",
};

/**
 * 팩 카테고리 코드를 화면 표시용 이름으로 변환한다.
 */
export function getCategoryName(category: string | undefined): string {
  return (category && CATEGORY_DISPLAY_MAP[category]) || category || "랜덤";
}
